import React from 'react';
import { TextField } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../../../../app/hooks';
import { updateLifecycle } from '../../../../state';

const MaxOccurrencesEdit: React.FC = () => {
  const dispatch = useAppDispatch();
  const { currentRecurringTask } = useAppSelector(state => state.recurringTask);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value === '' ? undefined : parseInt(event.target.value);
    dispatch(updateLifecycle({ maxOccurrences: value }));
  };

  return (
    <TextField
      label="Max Occurrences (Optional)"
      value={currentRecurringTask?.maxOccurrences || ''}
      onChange={handleChange}
      size="small"
      type="number"
      InputProps={{ inputProps: { min: 1 } }}
      sx={{ minWidth: 200 }}
      helperText="Max number of tickets to generate"
    />
  );
};

export default MaxOccurrencesEdit;
